/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { TestStageConfigRequestDto } from '../models';
// @ts-ignore
import type { TestStageConfigResponseDto } from '../models';
/**
 * TestStageConfigApi - axios parameter creator
 * @export
 */
export const TestStageConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the test configuration for the given stage, or 404 if not configured yet.
         * @summary Get test stage configuration
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestStageConfig: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestStageConfig', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestStageConfig', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test-config`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates the test configuration if it does not exist, or updates it if it does. Replaces sections entirely on each call. 
         * @summary Create or update test stage configuration
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {TestStageConfigRequestDto} testStageConfigRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertTestStageConfig: async (certificationId: number, stageId: number, testStageConfigRequestDto: TestStageConfigRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('upsertTestStageConfig', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('upsertTestStageConfig', 'stageId', stageId)
            // verify required parameter 'testStageConfigRequestDto' is not null or undefined
            assertParamExists('upsertTestStageConfig', 'testStageConfigRequestDto', testStageConfigRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test-config`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testStageConfigRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestStageConfigApi - functional programming interface
 * @export
 */
export const TestStageConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestStageConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the test configuration for the given stage, or 404 if not configured yet.
         * @summary Get test stage configuration
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestStageConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestStageConfig(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestStageConfigApi.getTestStageConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates the test configuration if it does not exist, or updates it if it does. Replaces sections entirely on each call. 
         * @summary Create or update test stage configuration
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {TestStageConfigRequestDto} testStageConfigRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertTestStageConfig(certificationId: number, stageId: number, testStageConfigRequestDto: TestStageConfigRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestStageConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertTestStageConfig(certificationId, stageId, testStageConfigRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestStageConfigApi.upsertTestStageConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestStageConfigApi - factory interface
 * @export
 */
export const TestStageConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestStageConfigApiFp(configuration)
    return {
        /**
         * Returns the test configuration for the given stage, or 404 if not configured yet.
         * @summary Get test stage configuration
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestStageConfigResponseDto> {
            return localVarFp.getTestStageConfig(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates the test configuration if it does not exist, or updates it if it does. Replaces sections entirely on each call. 
         * @summary Create or update test stage configuration
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {TestStageConfigRequestDto} testStageConfigRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertTestStageConfig(certificationId: number, stageId: number, testStageConfigRequestDto: TestStageConfigRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestStageConfigResponseDto> {
            return localVarFp.upsertTestStageConfig(certificationId, stageId, testStageConfigRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestStageConfigApi - interface
 * @export
 * @interface TestStageConfigApi
 */
export interface TestStageConfigApiInterface {
    /**
     * Returns the test configuration for the given stage, or 404 if not configured yet.
     * @summary Get test stage configuration
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStageConfigApiInterface
     */
    getTestStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestStageConfigResponseDto>;

    /**
     * Creates the test configuration if it does not exist, or updates it if it does. Replaces sections entirely on each call. 
     * @summary Create or update test stage configuration
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {TestStageConfigRequestDto} testStageConfigRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStageConfigApiInterface
     */
    upsertTestStageConfig(certificationId: number, stageId: number, testStageConfigRequestDto: TestStageConfigRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TestStageConfigResponseDto>;

}

/**
 * TestStageConfigApi - object-oriented interface
 * @export
 * @class TestStageConfigApi
 * @extends {BaseAPI}
 */
export class TestStageConfigApi extends BaseAPI implements TestStageConfigApiInterface {
    /**
     * Returns the test configuration for the given stage, or 404 if not configured yet.
     * @summary Get test stage configuration
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStageConfigApi
     */
    public getTestStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return TestStageConfigApiFp(this.configuration).getTestStageConfig(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates the test configuration if it does not exist, or updates it if it does. Replaces sections entirely on each call. 
     * @summary Create or update test stage configuration
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {TestStageConfigRequestDto} testStageConfigRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStageConfigApi
     */
    public upsertTestStageConfig(certificationId: number, stageId: number, testStageConfigRequestDto: TestStageConfigRequestDto, options?: RawAxiosRequestConfig) {
        return TestStageConfigApiFp(this.configuration).upsertTestStageConfig(certificationId, stageId, testStageConfigRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

